import React from 'react';

// Infinite horizontal band. Content is duplicated once so the CSS
// translateX(-50%) loop is seamless. Pauses on hover; static under
// reduced motion (see index.css).
export default function Marquee({ children, speed = 40, className = '' }) {
  return (
    <div className={`marquee overflow-hidden ${className}`} aria-hidden="true">
      <div className="marquee-track flex w-max" style={{ '--marquee-speed': `${speed}s` }}>
        <div className="flex shrink-0 items-center">{children}</div>
        <div className="flex shrink-0 items-center">{children}</div>
      </div>
    </div>
  );
}
